import { DropDown } from "../../../common/components/DropDown";

type Props = {
  chartViewMode: "individual" | "combined";
  setChartViewMode: React.Dispatch<
    React.SetStateAction<"individual" | "combined">
  >;
};

function GraphVariateSelector({ chartViewMode, setChartViewMode }: Props) {
  const chatViewSelectOptions = [
    { label: "Univariate", value: "individual" },
    { label: "Multivariate", value: "combined" },
  ];

  return (
    <DropDown
      value={chartViewMode}
      name="Chart View"
      options={chatViewSelectOptions}
      onChange={(e) => {
        setChartViewMode(e.target.value as "individual" | "combined");
      }}
    />
  );
}

export { GraphVariateSelector };
